import { Component, inject, signal, effect, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../../../core/services/auth.service';
import { RouterModule } from '@angular/router';
import { NewsManager } from '../news-manager/news-manager';
import { FileUpload } from '../file-upload/file-upload';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [RouterModule, NewsManager, FileUpload, CommonModule],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.css'
})
export class Dashboard {
  authService = inject(AuthService);
  private platformId = inject(PLATFORM_ID);

  activeTab = signal<'news' | 'files'>(this.getInitialTab());

  constructor() {
    // Save active tab to localStorage when it changes
    effect(() => {
      if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem('admin-active-tab', this.activeTab());
      }
    });
  }

  private getInitialTab(): 'news' | 'files' {
    if (isPlatformBrowser(this.platformId)) {
      const saved = localStorage.getItem('admin-active-tab');
      if (saved === 'files' || saved === 'news') {
        return saved;
      }
    }
    return 'news';
  }

  setActiveTab(tab: 'news' | 'files') {
    this.activeTab.set(tab);
  }

  onLogout() {
    this.authService.logout();
  }
}
